export default "__VITE_ASSET__07a7c367__"